import {LocalizationModuleError} from "../../errors/LocalizationModuleError";
import {LocalizationModuleErrorConstants} from "../../errors/LocalizationModuleErrorConstants";
import {ILocaProcessor} from "../../processors/api/ILocaProcessor";
import {ILocalizationService} from "../api/ILocalizationService";
import {LanguageVO} from "../../vos/LanguageVO";
import {LanguageData} from "../../parsers/LanguageMetaData";
import {getLogger} from "@goodgamestudios/logger";

const logger = getLogger("LocalizationJS.LocalizationService");

/**
 * @private
 */
export class LocalizationService implements ILocalizationService {
    private static PIPE_CHAR: string = "|";

    private _usePipe: boolean = false;

    constructor(private _processor: ILocaProcessor) {
    }

    public initialize(languageVO: LanguageVO, texts: any, cldrJSONData?: any, usePipe: boolean = false): void {
        if (!languageVO) {
            throw new LocalizationModuleError(
                LocalizationModuleErrorConstants.MESSAGE_LANGUAGE_VO_IS_MANDATORY,
                LocalizationModuleErrorConstants.CODE_LANGUAGE_VO_IS_MANDATORY
            );
        }

        this._usePipe = usePipe;
        logger.debug("initializing service with lang ", languageVO.locale);
        this._processor.initialize(languageVO, texts, cldrJSONData);
    }

    public finalize(): void {
        logger.debug("finalize service");

    }

    public setTexts(texts: LanguageData): void {
        this._processor.setTexts(texts);
    }

    public setLanguageAsync(language: LanguageVO, texts: LanguageData): Promise<any> {
        return this._processor.setLanguageAsync(language, texts);
    }


    public get initialized(): boolean {
        return this._processor.initialized;
    }

    public get usePipe(): boolean {
        return this._usePipe;
    }

    public set usePipe(value: boolean) {
        this._usePipe = value;
    }

    public get pipe(): string {
        return this._usePipe ? LocalizationService.PIPE_CHAR : "";
    }

    public get localizeReplacements(): boolean {
        return this._processor.localizeReplacements;
    }

    public set localizeReplacements(value: boolean) {
        this._processor.localizeReplacements = value;
    }

    public get locale(): string {
        return this._processor.getLocale();
    }

    /**
     * The language value is a 2-char tag describes a language(eg: en, fr, ru etc.)
     * Exception is Chinese which use tags zh-CN and zh-TW.
     *
     * This value is used to load proper translation file.
     *
     * Possible values MUST BE synchronized with country table values;
     */
    public get language(): string {
        //  this changed over time.  now locale and language are the same thing.
        return this.locale;
    }

    public get timeZone(): string {
        return this._processor.getTimeZone();
    }

    public get languageDataVersion(): string {
        return this._processor.textsVersionNo;
    }

    public get languageDataTimestamp(): string {
        return this._processor.textsDeployTime;
    }

    public get processorType(): string {
        return this._processor.processorType;
    }
}
